import {makeAutoObservable} from 'mobx';
import {getTime} from "html-evaluate-utils/DateFormat";
import {lc_user} from "clicker-common/src/staticData/lc_user";
import {ADMIN_CLAIM_KEY} from "../config/adminConfig";

export class AuthState {
    rootStore;
    user = lc_user;
    serverToken = null;
    adminClaims = {};

    constructor(rootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
    }

    authHeader(caller) {
        if(this.serverToken && typeof this.serverToken === 'string' && this.serverToken.length > 0) {
            return { Authorization: 'Bearer ' + this.serverToken};
        } else {
            return {};
        }
    }

    logEntry(method, caller) {
        console.log(`${getTime()} AuthState.${method}() <- ${caller}`);
    }

    setAdminClaims(claims = {}) {
        this.adminClaims = claims || {};
    }

    isSystemAdmin() {
        return this.adminClaims && this.adminClaims[ADMIN_CLAIM_KEY] === true;
    }
}
